import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Breadcrumb } from 'react-breadcrumbs'
import { useHistory, useRouteMatch } from 'react-router-dom'

import { Breadcrumbs } from 'Components/Breadcrumbs/index'
import { ClientEditWrapper } from 'Components/Clients/ClientEdit/ClientEditWrapper'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import { updateClientById } from 'Reducers/Clients/actions'
import { uploadClientImage } from 'Reducers/Upload/actions'
import ClientsIcon from 'Assets/Images/icons/clients'
import { PATHS } from 'Config/Routing/paths'
import ClientForm from '../ClientForm'
import { CLIENT_FORM_MODES } from '../const'
import { normalizeStatus } from '../utils'
import useGraphQLFetch from '../../../Utils/Hooks/useGraphQLFetch'
import { getClientAndTagsGQL } from './gql'
import { createClientTagLinkGQL, deleteClientTagLinkGQL } from './../gql'
import { convertArrayToHashMap } from '../../../shared/libraries/dataSets'

const BreadcrumbsClientEdit = ({ currentPath }) => (
  <div>
    <Breadcrumbs icon={<ClientsIcon style={{ width: 24 }} />} />
    <Breadcrumb
      data={{
        title: 'Clients',
        pathname: `${PATHS.main.dashboard}${PATHS.dashboard.clients}`,
      }}
    />
    <Breadcrumb
      data={{
        title: 'Edit',
        pathname: currentPath,
      }}
    />
  </div>
)

const updateClientTags = async ({ clientTags, formTags, id }) => {
  const formTagsMap = convertArrayToHashMap(formTags, 'id')
  const clientTagsMap = convertArrayToHashMap(clientTags, 'id')

  const createdTagLinksIds = formTags.reduce((acc, formTag) => {
    if (!clientTagsMap[formTag.id]) acc.push(formTag.id)
    return acc
  }, [])

  const deletedTagLinksIds = clientTags.reduce((acc, clientTag) => {
    if (!formTagsMap[clientTag.id]) acc.push(clientTag.tagLinkId)
    return acc
  }, [])

  if (deletedTagLinksIds.length !== 0) {
    await deleteClientTagLinkGQL({
      tagLinkIds: deletedTagLinksIds,
    })
  }

  if (createdTagLinksIds.length !== 0) {
    await createClientTagLinkGQL({ tagIds: createdTagLinksIds, clientId: id })
  }
}

const ClientEdit = () => {
  const match = useRouteMatch()
  const history = useHistory()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [client, setClient] = useState(null)
  const [allTags, setAllTags] = useState(null)
  const {
    params: { clientId },
  } = match

  const { data, isLoaded } = useGraphQLFetch({
    fetchFn: getClientAndTagsGQL,
    defaultFetchArgs: clientId,
    mapResponse: data => ({
      tags: data.getTags.edges.map(item => item.node),
      client: data.clients.nodes[0],
    }),
  })

  useEffect(() => {
    if (isLoaded) {
      setClient(data.client)
      setAllTags(data.tags)
    }
  }, [isLoaded])

  const navigateBack = () => {
    history.push(
      `${PATHS.main.dashboard}${PATHS.dashboard.clients}/${clientId}`,
    )
  }
  const callbackNavigateBack = {
    onSuccess: navigateBack,
  }

  const handleUpdateLogo = ({ clientId, logo }) => {
    const callbackUpdateClient = {
      onSuccess: imageUrl => {
        dispatch(
          updateClientById(callbackNavigateBack, clientId, { logo: imageUrl }),
        )
      },
    }
    dispatch(uploadClientImage(clientId, logo, callbackUpdateClient))
  }

  const handleClientEditFormSubmit = async (
    { name, code, status, tags },
    isValid,
    logo,
  ) => {
    if (isValid) {
      setLoading(true)
      const payload = {
        name: name.value,
        code: code.value,
        status: normalizeStatus(status.value),
      }

      await updateClientTags({
        clientTags: client.tags,
        formTags: tags.value,
        id: clientId,
      })

      if (logo) {
        const callbackUpdateLogo = {
          onSuccess: () => handleUpdateLogo({ clientId, logo }),
        }
        dispatch(updateClientById(callbackUpdateLogo, clientId, payload))
      } else {
        dispatch(updateClientById(callbackNavigateBack, clientId, payload))
      }
      setLoading(false)
    }
  }

  return (
    <LayoutDashboard>
      <HideWhenBlocked>
        <ClientEditWrapper>
          <BreadcrumbsClientEdit currentPath={match.url} />
          {client ? (
            <ClientForm
              handleSubmit={handleClientEditFormSubmit}
              mode={CLIENT_FORM_MODES.EDIT}
              buttonsDisabled={loading}
              handleCancel={navigateBack}
              defaultValues={client}
              tags={allTags}
            />
          ) : null}
        </ClientEditWrapper>
      </HideWhenBlocked>
    </LayoutDashboard>
  )
}

export default ClientEdit



// WEBPACK FOOTER //
// ./src/Containers/Clients/ClientEdit/index.js